import Link from "next/link";
import React from "react";
import styled from "styled-components";
import { Space } from "../../styled/Styled.sc";

const S = {
  Container: styled.div`
    padding: 15px;
    border-radius: 20px;
    box-shadow: 0 4px 15px #d2d2d2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    width: 100%;
    min-height: 250px;
  `,
  Avatar: styled.img`
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 100px;
  `,
  Name: styled.div`
    font-weight: 900;
    font-size: 18px;
  `,
  Description: styled.div`
    font-weight: 600;
    font-size: 14px;
  `,
  ArticlesLink: styled(Link)`
    font-size: 14px;
  `,
};

/**
 * @param {Object} props
 * @param {Object} props.author
 * @param {string} props.author.name
 * @param {number} props.author.pk
 * @param {number} props.author.user
 * @param {string} props.author.image
 * @param {string} props.author.description
 * @param {string} props.author.email
 * @param {boolean} props.author.hide_on_homepage
 * @param {any[]} props.author.law_firms
 * @param {string} props.author.phone
 * @param {string} props.author.specialization
 * @param {null} props.author.newsletter_image
 * @param {number} props.author.site
 * @param {null} props.author.additional_image
 */
export const AuthorCard = ({ author }) => {
  const changeTextToHTML = () => (
    <div dangerouslySetInnerHTML={{ __html: author.description }} />
  )

  if (author.description) {
     return (
        <S.Container>
        <div>
          <S.Avatar src={author.image} />
          <Space y={10} />
          <S.Name>{author.name}</S.Name>
        </div>
        <Space y={10} />
        <S.Description>{author.description ? changeTextToHTML() : null}</S.Description>
        <Space y={10} />
        <S.ArticlesLink href={`/artykuly/redaktorzy/${author.pk}`} as="a">
          Wszystkie artykuły
        </S.ArticlesLink>
      </S.Container>
     )
  }
  return null
};
